module.exports = __webpack_public_path__ + "img/h_jasmine_main.jpg";